import { IconClass } from '../../../_metronic/helpers/enumsUI'

export type CorTriagem = 'VERMELHO' | 'LARANJA' | 'AMARELO' | 'VERDE'

/**
 * Tom do selo: preenchimento sólido `--app-fill-<tom>` do tema (`_variables.custom.scss`).
 * `orange` é token próprio do app — o Bootstrap não tem laranja.
 */
export type TomRisco = 'danger' | 'orange' | 'warning' | 'success'

export type TokenRisco = {
  cor: CorTriagem
  nome: string
  prioridade: string
  /** Forma diferente por nível (Bootstrap Icons): cor sempre com nome e ícone (BRAND.md). */
  icone: IconClass
  tom: TomRisco
}

export const RISCOS: Record<CorTriagem, TokenRisco> = {
  VERMELHO: {
    cor: 'VERMELHO',
    nome: 'Vermelho',
    prioridade: 'Emergência',
    icone: IconClass.CircleFill,
    tom: 'danger',
  },
  LARANJA: {
    cor: 'LARANJA',
    nome: 'Laranja',
    prioridade: 'Muito urgente',
    icone: IconClass.DiamondFill,
    tom: 'orange',
  },
  AMARELO: {
    cor: 'AMARELO',
    nome: 'Amarelo',
    prioridade: 'Urgente',
    icone: IconClass.TriangleFill,
    tom: 'warning',
  },
  VERDE: {
    cor: 'VERDE',
    nome: 'Verde',
    prioridade: 'Pouco urgente',
    icone: IconClass.SquareFill,
    tom: 'success',
  },
}

/** Gravidade da cor: quanto maior, mais grave (mesma escala do backend). */
export const ORDEM_RISCO: CorTriagem[] = ['VERMELHO', 'LARANJA', 'AMARELO', 'VERDE']

export const tokenDoRisco = (cor?: string | null): TokenRisco | undefined =>
  cor ? RISCOS[cor as CorTriagem] : undefined
